import React from 'react';

/** Placeholder agent bubble, shown while a reply is in flight. */
export default function ReplyWaitIndicator() {
  return (
    <div className="py-2.5" role="status" aria-label="Waiting for a reply">
      <div className="w-fit rounded-2xl border border-hairline bg-surface px-4 py-3">
        <div className="flex items-center gap-1.5">
          <span className="h-1.5 w-1.5 animate-bounce rounded-full bg-ink-faint [animation-delay:-0.3s]" />
          <span className="h-1.5 w-1.5 animate-bounce rounded-full bg-ink-faint [animation-delay:-0.15s]" />
          <span className="h-1.5 w-1.5 animate-bounce rounded-full bg-ink-faint" />
        </div>
      </div>
    </div>
  );
}
